import { render, staticRenderFns } from "./productGroup.vue?vue&type=template&id=63575152&scoped=true&"
import script from "./productGroup.vue?vue&type=script&lang=js&"
export * from "./productGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63575152",
  null
  
)

export default component.exports